import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import IssueProcessTransactionTable from './IssueProcessTransactionTable';
import ProcessPopup from './ProcessPopup';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import moment from 'moment';
import { da, de, te } from 'date-fns/locale';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import EmployeePopUp from './EmployeePopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class IssueProcessTransaction extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            itemRowData: [],
            dtSerial: [],
            isModalOpen: false,
            isProcessOpen: false,
            isEmployeePopUpOpen: false,
            isModalOpenForEditItem: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            idPlant: 0,
            table2Data: [],
            table2ColDefs: [],
            firstList: [],
            secondList: [],
            tempSecondList: [],
            employeeWiseQtyList: [],
            open: false,
            isSelectItemPopUp: false,
            isSelectNoList2PopUp: false,
            employeeObject: {
                idMaterialIssueJobWorkDetails: 0,
                idEmployee: 0,
                allocatedQty: 0,
                idProcess: 0,
                employeeName: '',
                processRates: 0,
            },
            isSubmitButtonLoading: false,
            processObject: {
                idMaterialIssueJobWork: 0,
                updateStatus: 0,
                jobworkNo: '',
                jobWorkDate: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                authEmpList: [],
                employee: 0,
                quantity: '',
                jwFromList: [
                    { label: 'Through Production', value: 1 },
                    { label: 'Through W.O', value: 2 },
                    { label: 'THROUGH MRS', value: 3 },
                ],
                idJwFrom: 1,
                drawingNo: '',
                usedQty: '',
                passQty: '',
                pendQty: '',
                rejQty: '',
                reworkQty: '',
                typeList: [
                    { value: 1, label: "RAW MATERIAL" },
                    { value: 2, label: "FINISHED GOODS" },
                    { value: 3, label: "SEMI FINISHED" },
                    { value: 4, label: "SCRAP MATERIAL" },
                ],
                idType: 1,
                itemList: [],
                idItem: 0,
                itemName: '', //productName
                wo1: '',
                wo2: '',
                plantList: [],
                employeeList: [],
                plantId1: 0,
                plantId2: 0,
                woDate1: '',
                actualIDItem: '',
                //woDate2: '',
                selectNoList: [
                    { label: 'GENERATE NEW NUMBER', value: 1 },
                    { label: 'OLD NUMBER', value: 2 }
                ],
                idSelectNo1: 1,
                selectNoList2Col: [],
                selectNoList2: [],
                productionNo: '',
                idSelectNo2: 0,
                isCompleteProcess: false,
                date: '',
                remarks: '',
                idMaterialProduction: 0,
                idMaterialIssue: 0,
                colPendingJobWorkData: [],
                pendingJobWorkDataList: [],
                pendingJobWorkDataList2: [],
                e_Date: '',
            },
            selectItemColDefs: [],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                employee: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "auth employee"
                        ),
                    },
                ],
                idPlant: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "plant"
                        ),
                    },
                ],
                idType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                idProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                idNumber: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };
    // onRowDoubleClicked = async (event) => {
    //     this.bindIPTNo();
    //     let validState = this.state.validState;
    //     validState.isValid = true;
    //     validState.error = {};
    //     this.setState({
    //         validState: validState
    //     }, () => {
    //         this.usp_Transaction_MaterialIssue_JobWorkSelectbyID(event.data.idMaterialIssueJobWork);
    //     });
    // };
    onRowDoubleClicked = async (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        try {
            // Reset validation state
            let validState = this.state.validState;
            validState.isValid = true;
            validState.error = {};

            this.setState({ validState });

            // Execute all operations sequentially
            await this.bindIPTNo();
            await this.usp_Transaction_MaterialIssue_JobWorkSelectbyID(event.data.idMaterialIssueJobWork);

            // Modal will open automatically after all processes complete
            // (handled in usp_Transaction_MaterialIssue_JobWorkSelectbyID)
        } catch (error) {
            console.error("Error in onRowDoubleClicked:", error);
            this.SwalServices.Error("Something went wrong while loading data.");
        }
    };
    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};

        let details = this.state.processObject
        details.idMaterialIssueJobWork = 0
        details.updateStatus = 0
        details.jobWorkDate = moment(new Date().toISOString()).format('YYYY-MM-DD')
        details.employee = 0
        details.quantity = ''
        details.idJwFrom = 1
        details.drawingNo = ''
        details.usedQty = ''
        details.passQty = ''
        details.pendQty = ''
        details.rejQty = ''
        details.reworkQty = ''
        details.idType = 1
        details.idItem = 0
        details.itemName = ''
        details.wo1 = ''
        details.wo2 = ''
        details.plantId1 = 0
        details.plantId2 = 0
        details.woDate1 = ''
        details.actualIDItem = ''
        details.idSelectNo1 = 1
        details.productionNo = ''
        details.idSelectNo2 = 0
        details.isCompleteProcess = false
        details.date = ''
        details.remarks = ''
        details.idMaterialProduction = 0
        details.idMaterialIssue = 0
        details.e_Date = ''
        details.pendingJobWorkDataList2 = []
        details.pendingJobWorkDataList = []

        this.setState({
            validState: validState,
            processObject: details
        });
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetAllDetailsFields();
        this.setState({ isModalOpen: true, open: false }, () => {
            this.loadInitialData();
        })
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.processObject;
        data.idMaterialIssue = event.data.idMaterialIssue;
        data.itemName = event.data.itemName;
        this.setState({ processObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp, itemRowData: [] }, () => {
            this.cmbItem_EditValueChanged(event.data.idMaterialIssue)
        });
    };

    setOpenModel3 = () => {
        this.setState({ isSelectNoList2PopUp: !this.state.isSelectNoList2PopUp });
    };

    handleDropdownCellClick3 = (event) => {
        let data = this.state.processObject;
        data.idSelectNo2 = event.data.idMaterialProduction;
        data.productionNo = event.data.productionNo;
        this.setState({ processObject: data, isSelectNoList2PopUp: !this.state.isSelectNoList2PopUp });
    };

    handleOnClick = (event, name) => {
        if (name === 'itemList') {
            this.setOpenModel2();
        }
        if (name === 'productionNo') {
            this.setOpenModel3();
        }
    }

    setProcessModel = () => {
        this.setState({ isProcessOpen: !this.state.isProcessOpen });
    };
    setEmployeePopupModel = () => {
        this.setState({ isEmployeePopUpOpen: !this.state.isEmployeePopUpOpen });
    };
    processModel = () => {
        this.setState({ isProcessOpen: true });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    back = () => {
        this.setState({ open: !this.state.open });
    }

    handleChange = (event, name, field) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.processObject;
        if (name === "isCompleteProcess") {
            details.isCompleteProcess = !details.isCompleteProcess;
            details.date = details.isCompleteProcess ? moment(new Date().toISOString()).format('YYYY-MM-DD') : details.date;
        } else {
            details[name] = value;
        }
        this.setState({ processObject: details }, () => {
            if (name === "passQty") {
                this.calculateHandleChanges();
            }
        });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.processObject;
        let value = event.value;
        details[name] = value;
        this.setState({ processObject: details }, () => {
            if (name === "Jobwork from") {
                this.getMaster_ItemSelectbyItemType(event.label);
            } else if (name === "idSelectNo1") {
                this.cmbSerialNoFrom_SelectedIndexChanged();
            }
        });
    }

    handleChangeForDropdownForEmployee = (event, name, field) => {
        let details = this.state.employeeObject;
        let value = event.value;
        details[name] = value;
        details.employeeName = event.label;
        this.setState({ employeeObject: details });
    }

    handleChangeForEmployee = (event, name, field) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.employeeObject;
        details[name] = value;
        this.setState({ employeeObject: details });
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClickForSecondTable = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idMaterialIssueJobWork);
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, idPlant: prop.idPlant, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                //this.loadInitialData();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Issue Process Transaction",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialIssueJobWork", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Issue Process Transaction",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            // this.getPrefixSelectPrefix();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                        // this.loadInitialData();
                    }
                    this.loadInitialData()

                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                this.loadInitialData()
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "jobWorkNo": window.innerWidth * 0.05,
            "jobWorkFrom": window.innerWidth * 0.1,
            "workOrderNo": window.innerWidth * 0.05,
            "productionNo": window.innerWidth * 0.05,
            "jobWorkDate": window.innerWidth * 0.09,
            "itemName": window.innerWidth * 0.15,
            "quantity": window.innerWidth * 0.06,
            "passQty": window.innerWidth * 0.06,
            "issueNo": window.innerWidth * 0.05,
            "completeStatus": window.innerWidth * 0.08,
            "completeDate": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Issue Process Transaction",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        dynamicData.map((temp) => {
                            temp.completionDate = moment(temp.completionDate).format('DD-MM-YYYY');
                            temp.startDate = moment(temp.startDate).format('DD-MM-YYYY')
                        });
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        }, () => {
                            // this.loadInitialData();
                        });
                    }
                }
            });
        }
    }

    getEmployeeList = (idProcess, isCompeltedProcess) => {
        let request = [this.state.idCompany, idProcess ? idProcess : 0];
        this.transactionStockServices.usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idEmployee,
                        label: x.employeeName,
                    }));
                }
                let details = this.state.processObject;
                details.employeeList = dynamicData
                this.setState({ processObject: details }, () => {
                    this.setState({ isEmployeePopUpOpen: isCompeltedProcess ? true : false })
                })
            } else {
                this.SwalServices.Error(response.message);
                this.setState({ isEmployeePopUpOpen: true })
            }
        })
            .catch((err) => {
                this.SwalServices.Error("Something went wrong: " + err.message);
            });
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.07,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.3,
            "quantity": window.innerWidth * 0.05,
            "rate": window.innerWidth * 0.05,
        }
        return colwidth[key]
    }

    loadInitialData = async () => {
        let plantList = await this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany);
        plantList = plantList?.responseItem?.responseContent ? plantList?.responseItem?.responseContent.map((item) => {
            return {
                label: item.plantDetails,
                value: item.idPlant
            };
        }) : [];

        let object = this.state.processObject;
        object.plantList = plantList;

        this.setState({ processObject: object }, () => {
            this.getCount();
            this.cmbJobWorkFrom_SelectedIndexChanged();
            this.loadPendingItemData();
            // this.getMaster_ItemSelectbyItemType('FINISHED GOODS');
        });
    }

    getCount = async () => {
        // let list = this.state.rowData;
        // let maxIdPaymentMake = list.length > 0
        //     ? Math.max(...list.map(item => item.idMaterialIssueJobWork))
        //     : 0;
        // let jobworkNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        // let data = this.state.processObject;
        // data.jobworkNo = jobworkNo;
        // this.setState({
        //     processObject: data
        // }, () => {
        // });

        this.transactionStockServices.usp_Transaction_IssueProcessTransactionCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let processObject = this.state.processObject
                processObject.jobworkNo = formatted
                processObject.jobWorkDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ processObject: processObject })
            }
        });
    }

    cmbJobWorkFrom_SelectedIndexChanged = async () => {
        let request = [this.state.idCompany, this.state.processObject.updateStatus, this.state.processObject.idMaterialIssueJobWork, 0];
        if (this.state.processObject.idJwFrom === 1) {
            this.transactionStockServices.usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let itemObject = this.state.processObject;
                    // data.map((temp) => itemObject.sRNo.);
                    data.map((x, y) => {
                        x.sRNo = y + 1;
                    });
                    itemObject.itemList = data;
                    itemObject.idItem = itemObject.idItem > 0 ? itemObject.idItem : 0;
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0])
                            .filter(key => key !== 'idMaterialIssue' && key !== 'sR.No')
                            .map((key) => ({
                                field: key,
                                headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                    key.replace(/([A-Z])/g, ' $1').slice(1),
                                minWidth: this.getColumnWidth2(key) !== undefined
                                    ? this.getColumnWidth2(key)
                                    : window.innerWidth * 0.06,
                                filter: true,
                                floatingFilter: true,
                                flex: 1,
                            }));
                        this.setState({
                            processObject: itemObject,
                            selectItemColDefs: dynamicColDefs
                        });
                    }
                }
            });
        }
    }

    cmbSerialNoFrom_SelectedIndexChanged = () => {
        if (this.state.processObject.idSelectNo1 === 1) {
            this.setState({ cmbIPTNoReadOnly: true }, () => {
            });
        } else {
            this.setState({ cmbIPTNoReadOnly: false }, () => {
                this.bindIPTNo();
            });
        }
    }

    // bindIPTNo = async () => {
    //     let request = [this.state.idCompany];
    //     this.transactionStockServices.usp_Transaction_MaterialProduction_Serial_Select_ForAssembly(request).then((response) => {
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent;
    //             let itemObject = this.state.processObject;
    //             itemObject.selectNoList2 = data;

    //             if (data.length > 0) {
    //                 const dynamicColDefs = Object.keys(data[0])
    //                     .filter(key => key !== 'idMaterialProduction')
    //                     .map((key) => ({
    //                         field: key,
    //                         headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
    //                             key.replace(/([A-Z])/g, ' $1').slice(1),
    //                         minWidth: this.getColumnWidth2(key) !== undefined
    //                             ? this.getColumnWidth2(key)
    //                             : window.innerWidth * 0.06,
    //                         filter: true,
    //                         floatingFilter: true,
    //                         flex: 1,
    //                     }));
    //                 itemObject.selectNoList2Col = dynamicColDefs;
    //             }
    //             this.setState({
    //                 processObject: itemObject,
    //             });
    //         }
    //     });
    // }
    bindIPTNo = async () => {
        try {
            let request = [this.state.idCompany];
            const response = await this.transactionStockServices.usp_Transaction_MaterialProduction_Serial_Select_ForAssembly(request);

            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = { ...this.state.processObject };
                itemObject.selectNoList2 = data;

                if (data.length > 0) {
                    const dynamicColDefs = Object.keys(data[0])
                        .filter(key => key !== 'idMaterialProduction')
                        .map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined
                                ? this.getColumnWidth2(key)
                                : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                    itemObject.selectNoList2Col = dynamicColDefs;
                }

                // Use Promise to wait for setState
                await new Promise((resolve) => {
                    this.setState({ processObject: itemObject }, resolve);
                });
            }
        } catch (error) {
            console.error("Error in bindIPTNo:", error);
            throw error;
        }
    };

    // loadPendingItemData = () => {
    //     let request = [this.state.idCompany, 0];
    //     this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkSelectPendingItem(request).then((response) => {
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent;
    //             let itemObject = this.state.processObject;
    //             itemObject.pendingJobWorkDataList = data;

    //             if (data.length > 0) {
    //                 const dynamicColDefs = Object.keys(data[0])
    //                     .filter(key => key !== 'idMaterialIssueJobWork')
    //                     .map((key) => ({
    //                         field: key,
    //                         headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
    //                             key.replace(/([A-Z])/g, ' $1').slice(1),
    //                         minWidth: this.getColumnWidth2(key) !== undefined
    //                             ? this.getColumnWidth2(key)
    //                             : window.innerWidth * 0.06,
    //                         filter: true,
    //                         floatingFilter: true,
    //                         flex: 1,
    //                     }));
    //                 itemObject.colPendingJobWorkData = dynamicColDefs;
    //             }
    //             this.setState({
    //                 processObject: itemObject,
    //             });
    //         }
    //     });
    // }
    loadPendingItemData = async () => {
        try {
            let request = [this.state.idCompany, 0];
            const response = await this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkSelectPendingItem(request);

            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = { ...this.state.processObject };
                itemObject.pendingJobWorkDataList = data;

                if (data.length > 0) {
                    const dynamicColDefs = Object.keys(data[0])
                        .filter(key => key !== 'idMaterialIssueJobWork')
                        .map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined
                                ? this.getColumnWidth2(key)
                                : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                    itemObject.colPendingJobWorkData = dynamicColDefs;
                }

                // Use Promise to wait for setState
                await new Promise((resolve) => {
                    this.setState({ processObject: itemObject }, resolve);
                });
            }
        } catch (error) {
            console.error("Error in loadPendingItemData:", error);
            throw error;
        }
    };

    cmbItem_EditValueChanged = (id) => {
        let request = [id];
        this.transactionStockServices.usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let itemObject = this.state.processObject;
                itemObject.actualIDItem = data.idItem;
                itemObject.wo1 = data.idWorkOrder;
                itemObject.wo2 = data.idMaterialIssue;
                itemObject.quantity = data.totalProductionQty;
                itemObject.usedQty = data.pendingQty;
                itemObject.drawingNo = data.drawingNo;
                itemObject.passQty = 0;
                itemObject.pendQty = 0;
                itemObject.rejQty = 0;
                this.setState({
                    processObject: itemObject,
                });
            }
        });
    }

    calculateHandleChanges = () => {
        let details = this.state.processObject;
        let usedQty = parseFloat(details.usedQty) || 0;
        let passQty = parseFloat(details.passQty) || 0;
        let pendQty = usedQty - passQty;
        details.pendQty = pendQty;
        this.setState({ processObject: details });
    }

    btnAddPreocess_Click = () => {

        if (this.state.processObject.wo2 > 0 && this.state.processObject.quantity > 0)
            this.bindData(Number(this.state.processObject.actualIDItem));
        //if (cmbSerialNoFrom.Text.Equals("GENERATE NEW NUMBER"))
        if (this.state.processObject.idSelectNo1 === 1) {
            this.bindSerialNo(this.state.processObject.wo2);
        }
        if (this.state.processObject.idSelectNo1 === 2) {
            this.bindOldSerialNo();
        }
    }

    bindData = async (id) => {
        try {
            let itemRowData = [];
            const request = [id];
            const processItemSelectbyIDItem = (await this.transactionStockServices.usp_Master_ProcessItemSelectbyIDItem(request))?.responseItem?.responseContent;

            if (processItemSelectbyIDItem && processItemSelectbyIDItem.length > 0) {
                let previousProcessCompleted = true;

                for (let index = 0; index < processItemSelectbyIDItem.length; index++) {
                    const element = processItemSelectbyIDItem[index];
                    let item = {
                        idMaterialIssue: 0,
                        idMaterialIssueProcess: 0,
                        processDetails: element?.process,
                        idProcess: element?.idProcess,
                    };

                    if (this.state.processObject.updateStatus === 1) {
                        const req2 = [
                            this.state.processObject.idMaterialIssueJobWork,
                            element?.idProcess,
                        ];
                        const jobWorkData = (await this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkSelectbyID(req2))?.responseItem?.responseContent;
                        const detailsList = jobWorkData?.[1] || [];
                        if (detailsList.length > 0) {
                            const dr1 = detailsList[0];
                            item.isSelected = true;
                            item.idMaterialIssueJobWorkDetails = dr1.idMaterialIssueJobWorkDetails;
                            item.isStart = dr1.isStart;
                            item.sequenceNo = dr1.sequenceNo === 0 ? element.sequenceNo : dr1.sequenceNo;
                            item.startDate = dr1.startDate ? moment(dr1.startDate).format("YYYY-MM-DD") : '';
                            item.employee = dr1.employeeName;
                            item.idEmployee = dr1.idEmployee;
                            item.isComplete = dr1.isComplete;
                            item.completionDate = dr1.completionDate ? moment(dr1.completionDate).format("YYYY-MM-DD") : '';
                            item.quantity = dr1.quantity;
                            item.jobWork = dr1.isJobWork;
                            item.isQc = dr1.isQC;
                            item.qcDate = dr1.qcDate ? moment(dr1.qcDate).format("YYYY-MM-DD") : '';
                            item.qcEmployee = dr1.qcEmployee;
                            item.remarks = dr1.remarks;
                            item.pendingQty = dr1.pendingQty;
                            item.isPending = dr1.isPending;
                            item.passQty = dr1.passQty;
                            item.rejectQty = dr1.rejectQty;
                            item.reWorkQty = dr1.reWorkQty || 0;
                            item.processRates = (dr1?.processRates === null || dr1?.processRates === undefined || dr1?.processRates === 0) ? element.processRates : dr1?.processRates;
                            item.isDisabled = index > 0 && !previousProcessCompleted;
                            previousProcessCompleted = dr1.isComplete
                        } else {
                            item.sequenceNo = element.sequenceNo;
                            item.isSelected = false;
                            item.idMaterialIssueJobWorkDetails = 0;
                            item.isStart = false;
                            item.startDate = null;
                            item.employee = "";
                            item.isComplete = false;
                            item.completionDate = null;
                            item.jobWork = false;
                            item.quantity = this.state.processObject.usedQty || 0;
                            item.passQty = this.state.processObject.usedQty || 0;
                            item.rejectQty = 0;
                            item.reWorkQty = 0;
                            item.isQc = false;
                            item.qcDate = null;
                            item.qcEmployee = "";
                            item.remarks = "";
                            item.pendingQty = 0;
                            item.isPending = false;
                            item.processRates = element?.processRates || 0;
                            item.isDisabled = index > 0 && !previousProcessCompleted;
                            previousProcessCompleted = false;
                        }
                    }
                    else {
                        item.sequenceNo = element.sequenceNo;
                        item.isSelected = false;
                        item.idMaterialIssueJobWorkDetails = 0;
                        item.isStart = false;
                        item.startDate = null;
                        item.employee = "";
                        item.isComplete = false;
                        item.completionDate = null;
                        item.jobWork = false;
                        item.quantity = this.state.processObject.usedQty || 0;
                        item.passQty = this.state.processObject.usedQty || 0;
                        item.reWorkQty = 0;
                        item.rejectQty = 0;
                        item.isQc = false;
                        item.qcDate = null;
                        item.qcEmployee = "";
                        item.remarks = "";
                        item.pendingQty = 0;
                        item.isPending = false;
                        item.processRates = element?.processRates || 0;
                        item.isDisabled = index > 0;
                    }

                    itemRowData.push(item);
                }
            } else {
                this.SwalServices.Alert("No Process Found for this Item.");
            }

            // this.setState({ itemRowData }, () => {
            //     this.setState({ isModalOpen: true })
            // });
            await new Promise((resolve) => {
                this.setState({ itemRowData }, resolve);
            });

        } catch (error) {
            console.error("Error in bindData:", error);
        }
    };

    bindSerialNo = (id) => {
        try {
            if (id > 0 && this.state.processObject.quantity > 0) {
                let dtSerial = [];
                const apqty = Number(this.state.processObject.quantity);

                if (apqty > 0) {
                    for (let i = 0; i < apqty; i++) {
                        dtSerial.push({
                            idMaterialIssueSerialNoDetails: this.state.processObject.idMaterialIssueJobWork || 0,
                            idItem: this.state.processObject.wo2 || 0,
                            itemName: this.state.processObject.itemName || "",
                            serialNo: 0,
                            remarks: "",
                        });
                    }
                }
                this.setState({ dtSerial: dtSerial });
            }
        } catch (error) {
            console.error("Error in bindSerialNo:", error);
        }
    };

    bindOldSerialNo = async () => {
        try {
            const request = [this.state.processObject.idSelectNo2];
            const serialData = await this.transactionStockServices.usp_Transaction_MaterialProduction_SerialNoSelectbyID(request);

            if (serialData && serialData.length > 0) {
                const dtSerial = serialData.map((dr) => ({
                    idMaterialProductionIssueSerial: dr.idMaterialProductionIssueSerial,
                    idMaterialIssueJobWork: this.state.processObject.idMaterialIssueJobWork || 0,
                    idItem: dr.idItem,
                    itemName: dr.itemName,
                    serialNo: dr.serialNo,
                    remarks: dr.remarks,
                }));

                this.setState({ dtSerial: dtSerial });
            } else {
                this.setState({ dtSerial: [] });
            }
        } catch (error) {
            console.error("Error in bindOldSerialNo:", error);
        }
    };

    submit = () => {
        // if (Number(this.state.processObject.wo2) > 0 && Number(this.state.processObject.passQty) > 0 && this.state.itemRowData.length > 0) {
        if (!this.state.itemRowData[0].isSelected) {
            this.SwalServices.Error("Please select item for proceed.");
            return;
        }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
            return;
        }
        if (this.state.isSubmitButtonLoading) {
            return;
        }
        this.setState({ isSubmitButtonLoading: true }, () => {
            let details = this.state.processObject;
            let requestData = {
                idMaterialIssueJobWork: details.idMaterialIssueJobWork,
                jobWorkNo: details.jobworkNo,
                jobWorkDate: details.jobWorkDate,
                jobWorkFrom: details.jwFromList.find(x => x.value === details.idJwFrom)?.label.toUpperCase() || '',

                // Jobwork From - Through MRS
                idIndentRegister: details.idJwFrom === 3 ? details.idMaterialIssue : 0,//

                // Jobwork From - Through W.O.
                idWorkOrderRecv: details.idJwFrom === 2 ? details.wo1 : 0,
                workOrderNo: details.idJwFrom === 2 || details.idJwFrom === 1 ? details.wo1 : 0,
                workOrderDate: details.idJwFrom === 2 ? details.woDate1 : null,

                // Jobwork From - Through Production
                idMaterialProduction: details.idJwFrom === 1 ? details.idMaterialProduction : 0,
                idMaterialIssue: details.idJwFrom === 1 ? details.idMaterialIssue : 0,
                productionNo: details.idJwFrom === 1 ? Number(details.wo2) : 0,
                productionDate: details.idJwFrom === 1 ? details.woDate1 : null,

                idItem: details.actualIDItem,
                quantity: details.quantity,
                idEmployee: details.employee,
                isComplete: details.isCompleteProcess,
                completeDate: details.date,
                remarks: details.remarks,
                idCompany: this.state.idCompany,
                idCompanyDivision: 0,

                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                e_IDUser: this.state.idUser,
                isUpdated: details.updateStatus > 0 ? true : false,
                updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
                u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: 0,

                usedQty: details.usedQty,
                passQty: Number(details.passQty),
                pendingQty: details.pendQty,
                rejectQty: details.rejQty,
                idFinancialYear: null,
                itemRowData: [],
                dtSerial: [],
            }
            requestData.itemRowData = this.state.itemRowData;
            requestData.dtSerial = this.state.dtSerial;

            this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkInsertUpdate(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData?.errorType === "Exists") {
                            this.SwalServices.Warning(dynamicData.errorMessage);
                            this.setState({ isSubmitButtonLoading: false })
                        } else {
                            if (details.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                            }
                            // this.resetAllDetailsFields();
                            // this.resetDetailsFields();
                            // this.setState({ isModalOpen: false }, () => {
                            this.procSelectAllRecordsSP();
                            // });
                            this.usp_Transaction_MaterialIssue_JobWorkSelectbyID(dynamicData[0].idMaterialIssueJobWork);
                        }
                    } else {
                        this.setState({ isSubmitButtonLoading: false })
                        this.setState({ isModalOpen: false }, () => {
                            this.SwalServices.Error(response.message);
                            this.procSelectAllRecordsSP();
                        });
                    }
                })
                .catch((err) => {
                    this.SwalServices.Error("Something went wrong: " + err.message);
                    this.setState({ isSubmitButtonLoading: false })
                });
        })
        // } else {
        //     this.SwalServices.Error("Please Enter Valid Data.");
        // }
    };

    resetAllDetailsFields = () => {
        this.setState({
            itemRowData: [],
        });
    }

    usp_Transaction_MaterialIssue_JobWorkSelectbyID = async (id) => {
        try {
            const request = [id, 0];
            //const bindIPTNo = await 
            const response = await this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkSelectbyID(request);

            if (response.statusCode === 200 && response.responseItem !== null) {
                const ds = response.responseItem.responseContent;
                const table1 = ds[0][0];
                const table3 = ds[3] || [];

                let processObject = { ...this.state.processObject };
                let dtSerial = [];

                processObject.idMaterialIssueJobWork = table1.idMaterialIssueJobWork;
                processObject.updateStatus = 1;
                processObject.jobworkNo = table1.jobWorkNo || "";
                processObject.jobWorkDate = table1.jobWorkDate
                    ? moment(table1.jobWorkDate).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD");

                if (table1.jobWorkFrom?.toUpperCase() === "THROUGH PRODUCTION") {
                    processObject.idJwFrom = 1;
                    processObject.idSelectNo2 = Number(table1.idMaterialIssue) || 0;
                    processObject.idMaterialProduction = Number(table1.idMaterialProduction) || 0;
                    processObject.idMaterialIssue = Number(table1.idMaterialIssue) || 0;
                    processObject.productionNo = table1.productionNo || "";
                    processObject.wo1 = Number(table1.workOrderNo) || 0;
                    processObject.wo2 = table1.idMaterialIssue || 0;
                    processObject.woDate1 = table1.productionDate
                        ? moment(table1.productionDate).format("YYYY-MM-DD")
                        : "";
                } else if (table1.jobWorkFrom?.toUpperCase() === "THROUGH W.O." || table1.jobWorkFrom?.toUpperCase() === "THROUGH W.O") {
                    processObject.idJwFrom = 2;
                    processObject.wo1 = parseInt(table1.idWorkOrderRecv) || 0;
                    processObject.wo2 = table1.workOrderNo || "";
                    processObject.woDate1 = table1.workOrderDate
                        ? moment(table1.workOrderDate).format("YYYY-MM-DD")
                        : "";
                } else if (table1.jobWorkFrom?.toUpperCase() === "THROUGH MRS") {
                    processObject.idJwFrom = 3;
                    processObject.idMaterialProduction = table1.idIndentRegister || 0;
                    processObject.idMaterialIssue = table1.idIndentRegister || 0;
                }

                // ====== Common Fields ======
                processObject.drawingNo = table1.drawingNo || "";
                processObject.idType = this.getTypeValueByName(table1.itemType);
                processObject.actualIDItem = Number(table1.idItem) || 0;
                processObject.itemName = table1.itemName || "";
                processObject.quantity = table1.quantity || "";
                processObject.employee = parseInt(table1.idEmployee) || 0;
                processObject.remarks = table1.remarks || "";

                processObject.isCompleteProcess = Boolean(table1.isComplete);
                processObject.date = table1.completeDate
                    ? moment(table1.completeDate).format("YYYY-MM-DD")
                    : "";

                processObject.usedQty = table1.usedQty || "";
                processObject.passQty = table1.passQty || "";
                processObject.pendQty = table1.pendingQty || "";
                processObject.rejQty = table1.rejectQty || "";

                // ====== Serial No Details (table3) ======
                table3.forEach((row) => {
                    dtSerial.push({
                        idMaterialIssueSerialNoDetails: row.idMaterialIssueSerialNoDetails,
                        idMaterialIssueJobWork: row.idMaterialIssueJobWork,
                        idItem: row.idItem,
                        itemName: row.itemName,
                        serialNo: row.serialNo,
                        remarks: row.remarks,
                        globalUserID: table1.modifiedBy
                    });
                });

                // ====== Update State ======
                // this.setState({
                //     processObject: processObject,
                //     dtSerial: dtSerial,
                // }, () => {
                //     this.bindData(Number(processObject.actualIDItem));
                //     this.loadPendingItemData();
                // });

                await new Promise((resolve) => {
                    this.setState({
                        processObject: processObject,
                        dtSerial: dtSerial,
                    }, resolve);
                });

                await this.bindData(Number(processObject.actualIDItem));
                await this.loadPendingItemData();

                this.setState({ isModalOpen: true }, () => {
                    this.setState({ isSubmitButtonLoading: false })
                });
            }
        } catch (error) {
            console.error("Error loading JobWork data:", error);
            this.SwalServices.Error("Something went wrong while loading Job Work data.");
        }
    };

    getTypeValueByName = (name) => {
        const typeMap = {
            "RAW MATERIAL": 1,
            "FINISHED GOODS": 2,
            "SEMI FINISHED": 3,
            "SCRAP MATERIAL": 4,
        };
        return typeMap[name?.toUpperCase()] || 1;
    };

    handleIsStartChange = (params) => {
        const updatedItemRowData = this.state.itemRowData.map((item, index) => {
            if (index === params.rowIndex) {
                return {
                    ...item,
                    isStart: params.newValue,
                    startDate: params.newValue ? moment().format("YYYY-MM-DD") : null,
                };
            }
            return item;
        });
        let details = this.state.processObject;
        details.passQty = params.data.passQty
        this.setState({ processObject: details });
        this.setState({ itemRowData: updatedItemRowData });
    }


    handleIsCompleteChange = (params) => {
        const updatedItemRowData = this.state.itemRowData.map((item, index) => {
            if (index === params.rowIndex) {
                return {
                    ...item,
                    isComplete: params.newValue,
                    completionDate: params.newValue ? moment().format("YYYY-MM-DD") : null,
                };
            }
            return item;
        });
        this.setState({ itemRowData: updatedItemRowData });
    }

    handleIsEmployeeChange = (params, event) => {
        // const updatedItemRowData = this.state.itemRowData.map((item, index) => {
        //     if (index === params.rowIndex) {
        //         return {
        //             ...item,
        //             idEmployee: event.value ? event.value : 0,
        //             employee: event.label ? event.label : '',
        //         };
        //     }
        //     return item;
        // });
        // this.setState({ itemRowData: updatedItemRowData });
        let request = [
            params.data.idProcess,
            params.data.idMaterialIssueJobWorkDetails,
        ]

        this.transactionStockServices.getAllocatedQtyEmployeeWise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;

                let employeeObject = this.state.employeeObject
                let totalPassQty = data.reduce((total, item) => total + Number(item.allocatedQty), 0)
                employeeObject.allocatedQty = this.state.processObject.passQty - totalPassQty;
                employeeObject.processRates = params.data.processRates;
                this.setState({ employeeWiseQtyList: data })
            } else {
                this.SwalServices.Error(response.message);
            }
        })

        let details = this.state.employeeObject
        details.idProcess = params.data.idProcess
        details.idMaterialIssueJobWorkDetails = params.data.idMaterialIssueJobWorkDetails
        this.setState({ employeeObject: details }, () => {
            this.getEmployeeList(params.data.idProcess, params.data.idMaterialIssueJobWorkDetails > 0)
        })
    }

    handleIsPendingQtyChange = (params) => {
        const updatedItemRowData = this.state.itemRowData.map((item, index) => {
            if (index === params.rowIndex) {
                return {
                    ...item,
                    pendingQty: params.newValue,
                    isPending: params.pendingQty > 0 ? true : false,
                };
            }
            return item;
        });
        let details = this.state.processObject;
        details.pendQty = params.data.pendingQty;
        details.passQty = params.data.passQty - params.data.pendingQty;
        this.setState({ processObject: details });
        this.setState({ itemRowData: updatedItemRowData });
    }


    addEmployees = () => {
        if (this.state.employeeObject.allocatedQty > 0 && this.state.employeeObject.idEmployee > 0) {

            let totalAllocatedQty = 0;
            totalAllocatedQty = this.state.employeeWiseQtyList.reduce((total, item) => total + Number(item.allocatedQty), 0);
            if ((Number(totalAllocatedQty) + Number(this.state.employeeObject.allocatedQty)) > this.state.processObject.usedQty) {
                this.SwalServices.Error("Allocated quantity exceeds used quantity.");
                return;
            }

            let item = {
                idProcess: this.state.employeeObject.idProcess,
                idEmployee: this.state.employeeObject.idEmployee,
                employeeName: this.state.employeeObject.employeeName,
                allocatedQty: Number(this.state.employeeObject.allocatedQty),
                idMaterialIssueJobWorkDetails: this.state.employeeObject.idMaterialIssueJobWorkDetails,
            }
            let array = [...this.state.employeeWiseQtyList]
            array.push(item)
            this.setState({ employeeWiseQtyList: array }, () => {
                this.setState({
                    employeeObject: {
                        idEmployee: 0,
                        employeeName: '',
                        allocatedQty: 0,
                        idProcess: this.state.employeeObject.idProcess,
                        idMaterialIssueJobWorkDetails: this.state.employeeObject.idMaterialIssueJobWorkDetails,
                    }
                })
            })
        }
    }

    deleteEmployeeWiseQty = (params) => {
        let array = this.state.employeeWiseQtyList.filter(x => x.idEmployee !== params.data.idEmployee)
        this.setState({ employeeWiseQtyList: array })
    }

    addAllocatedQtyEmployeeWise = () => {
        let request = {}
        request.itemList = this.state.employeeWiseQtyList
        // when all rows are removed the list is empty, so fall back to the process/detail
        // IDs captured on employeeObject when the popup was opened (avoids reading [0] of [])
        const firstRow = this.state.employeeWiseQtyList[0];
        request.processId = firstRow ? firstRow.idProcess : this.state.employeeObject.idProcess
        request.idMaterialIssueJobWorkDetails = firstRow ? firstRow.idMaterialIssueJobWorkDetails : this.state.employeeObject.idMaterialIssueJobWorkDetails
        this.transactionStockServices.addAllocatedQtyEmployeeWise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                this.SwalServices.Success("Saved successfully.");
                this.usp_Transaction_MaterialIssue_JobWorkSelectbyID(this.state.processObject.idMaterialIssueJobWork);
                this.setState({ isEmployeePopUpOpen: false, employeeWiseQtyList: [] })
            } else {
                this.SwalServices.Error(response.message);
            }
        })
    }

    usp_Transaction_MaterialIssue_JobWorkRecordDelete = () => {
        this.SwalServices
            .Confirm("Delete Issue process Transaction", "Are you sure ?", "Yes", "No")
            .then((response) => {
                if (response) {
                    this.transactionStockServices.usp_Transaction_MaterialIssue_JobWorkRecordDelete(this.state.processObject.idMaterialIssueJobWork).then((response) => {
                        if (response.statusCode === 200 && response.responseItem !== null) {
                            this.SwalServices.Success('Deleted Successfully')
                            this.setState({ isModalOpen: false, isEmployeePopUpOpen: false, employeeWiseQtyList: [] })
                            this.resetAllDetailsFields()
                            this.resetDetailsFields()
                            this.procSelectAllRecordsSP()
                        } else {
                            this.SwalServices.Error(response.message);
                        }
                    })
                }
            });
    }

    downloadIssueProcessEmployeeReport = () => {
        if (this.state.processObject.idMaterialIssueJobWork > 0) {
            let request = [this.state.processObject.idMaterialIssueJobWork];
            this.transactionStockServices.downloadIssueProcessEmployeeReport(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL, "_blank");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    render() {
        return (
            <div className='store-to-plant' >
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <IssueProcessTransactionTable
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            processObject={this.state.processObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            dtSerial={this.state.dtSerial}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            back={this.back.bind(this)}
                            open={this.state.open}
                            processModel={this.processModel.bind(this)}
                            handleOnClick={this.handleOnClick.bind(this)}
                            btnAddPreocess_Click={this.btnAddPreocess_Click.bind(this)}
                            handleIsStartChange={this.handleIsStartChange.bind(this)}
                            handleIsCompleteChange={this.handleIsCompleteChange.bind(this)}
                            handleIsEmployeeChange={this.handleIsEmployeeChange.bind(this)}
                            handleIsPendingQtyChange={this.handleIsPendingQtyChange.bind(this)}
                            isSubmitButtonLoading={this.state.isSubmitButtonLoading}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                            permissions={this.state.permissions}
                            usp_Transaction_MaterialIssue_JobWorkRecordDelete={this.usp_Transaction_MaterialIssue_JobWorkRecordDelete.bind(this)}
                            downloadIssueProcessEmployeeReport={this.downloadIssueProcessEmployeeReport.bind(this)}
                        />
                        <ProcessPopup
                            isProcessOpen={this.state.isProcessOpen}
                            setProcessModel={this.setProcessModel.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Issue process transaction</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onCellClicked={this.handleCellClickForSecondTable}
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.processObject.itemList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
                <SelectItemListPopUp
                    modalName={"Select No"}
                    selectItemList={this.state.processObject.selectNoList2}
                    colDefs={this.state.processObject.selectNoList2Col}
                    isModalOpen={this.state.isSelectNoList2PopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick3}
                />
                <EmployeePopUp
                    isProcessOpen={this.state.isEmployeePopUpOpen}
                    setProcessModel={this.setEmployeePopupModel.bind(this)}
                    employeeObject={this.state.employeeObject}
                    employeeList={this.state.processObject.employeeList}
                    handleChangeForDropdownForEmployee={this.handleChangeForDropdownForEmployee.bind(this)}
                    handleChangeForEmployee={this.handleChangeForEmployee.bind(this)}
                    addEmployees={this.addEmployees.bind(this)}
                    passQty={this.state.processObject.passQty}
                    employeeWiseQtyList={this.state.employeeWiseQtyList}
                    deleteEmployeeWiseQty={this.deleteEmployeeWiseQty.bind(this)}
                    addAllocatedQtyEmployeeWise={this.addAllocatedQtyEmployeeWise.bind(this)}
                />
            </div >
        )
    }
}
